
import { mapState } from 'vuex'
export default {
  data() {
    return {
      show: false,
      headshow: true,
      cookiesshow: false
    }
  },
  computed: {
    ...mapState({
      cookieHost: 'cookieHost'
    })
  },
  mounted() {
    this.cookiesshow = !this.$Cookie.get('footer_tips')
  },
  methods: {
    tjfn() {
      // 埋点统计
      // this.show = true
      this.mdcountfn({
        event_name: 'Wiki_Cookie_Click'
      })
    },
    jjfn() {
      this.headshow = false
      this.$Cookie.set('footer_tips', true, {
        path: '/',
        expires: this.AddTime(10080 * 60),
        domain: this.cookieHost
      })
      this.mdcountfn({
        event_name: 'Wiki_Cookie_Accept_Click',
        type: '拒绝'
      })
    },
    jsfn() {
      this.headshow = false
      this.$Cookie.set('footer_tips', true, {
        path: '/',
        expires: this.AddTime(10080 * 60),
        domain: this.cookieHost
      })
      this.mdcountfn({
        event_name: 'Wiki_Cookie_Accept_Click',
        type: '接受'
      })
    },
    AddTime(time) {
      let dateTime = new Date()
      dateTime = new Date(dateTime.setTime(dateTime.getTime() + time * 1000))
      return dateTime
    },
    tagglefn() {
      if (!this.$store.state.mobile) return
      this.show = !this.show
    },
    onMouseEnter() {
      if (this.$store.state.mobile) return
      this.show = true
    },
    onMouseLeave() {
      if (this.$store.state.mobile) return
      this.show = false
    },
    close() {
      this.headshow = false
      this.mdcountfn({
        event_name: 'Wiki_Cookie_Cancel_Click'
      })
    }
  }
}
